/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-14 14:09:58
 * @LastEditTime: 2025-03-04 14:50:53
 */
import request from '@/utils/request';

// 商品详情
export const getDetail = (data:any) =>
  request({
    url: `product/detail.json?productSn=${data.productId}`,
  });
// 询价
export const priceEnquiry = (data:any) =>
  request({
    url: `product/enquiry/add.json`,
    method: 'post',
    data
  });